

jQuery(document).ready(function($) {

  function moveAccordionItems() {

    if($(window).width() > 970){
  
      if($('.site-accordion').hasClass('mobileVersion'))
        $('.site-accordion').removeClass('mobileVersion');
  
      if(!$('.site-accordion').hasClass('desktopVersion')){
        $('.site-accordion').addClass('desktopVersion');
  
        $('.site-accordion .site-accordion__item').each(function(index) {
          if(index%2==1){
            var itemID= $(this).attr('id').substring(8);
            $(this).insertAfter( $( ".site-accordion #LinkItem"+(itemID-1)) );
          }
        });
  
      }
      
    }else{
  
      if($('.site-accordion').hasClass('desktopVersion'))
        $('.site-accordion').removeClass('desktopVersion');
  
      if(!$('.site-accordion').hasClass('mobileVersion')){
        $('.site-accordion').addClass('mobileVersion');
  
        $('.site-accordion .site-accordion__content').each(function() {
          $(this).insertAfter( $( ".site-accordion #Link"+$( this ).attr('id') ) );
        });
  
      }
    }
  }

  $( window ).load(function() {
    setTimeout(function() {
      $(".site-loader").fadeOut("slow");
    }, 500);
  });

  var countImgLightbox=0;
  $("body:not(.woocommerce) a[href$='.jpg'],a[href$='.jpeg'],body:not(.woocommerce) a[href$='.png'],body:not(.woocommerce) a[href$='.gif'],body:not(.woocommerce) a[href$='.JPG'],body:not(.woocommerce) a[href$='.JPEG']").each(function(){
      $(this).attr('data-lightbox','gallery'+countImgLightbox);
      countImgLightbox++;
      if($(this).find('img').attr('alt')!='') $(this).attr('data-title',$(this).find('img').attr('alt'));
  });
  
  if($('.container-slider').length > 0){

    $(".container-slider").each(function(index) {
      
      var $this = $(this);

      if(is_touch_device()){
        if(!$this.hasClass('touchenabled'))
          $this.addClass('touchenabled');
      }else{
        if($this.hasClass('touchenabled'))
           $this.removeClass('touchenabled');
      }


      if($this.find('.slider-for').length >0){

        //check if is set slider for navigation
        if($this.find('.slider-nav').length >0){

          if(!$this.hasClass('noArrows')){ //se ha le frecce
            $this.find('.slider-for').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                fade: true,
                asNavFor: ".slider-nav.sl"+index
            });

            $this.find('.slider-nav').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                asNavFor: ".slider-for.sl"+index,
                dots: false,
                arrows: true,
                centerMode: false,
                focusOnSelect: true,
                autoplay: true,
                autoplaySpeed: 4000,
                responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                    }
                }
                ]
            });

          }else{ //se non ha le frecce
            $this.find('.slider-for').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                fade: true,
                asNavFor: ".slider-nav.sl"+index
            });

            $this.find('.slider-nav').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                asNavFor: ".slider-for.sl"+index,
                dots: false,
                arrows: false,
                centerMode: false,
                focusOnSelect: true,
                autoplay: true,
                autoplaySpeed: 4000,
                responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                    }
                }
                ]
            });
          }
        }else{

          if(!$this.hasClass('noArrows')){ //se ha le frecce
            if($this.hasClass('vertical')){ //vertical slider with arrows
                $this.find('.slider-for').slick({
                  dots: false,
                  arrows: true,
                  vertical: true,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  verticalSwiping: true,
                  centerMode: true,
                  centerPadding: '0',
                  autoplay: true,
                  autoplaySpeed: 4000
                });
            }else{
              $this.find('.slider-for').slick({
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  arrows: true,
                  dots: false,
                  fade: true,
                  autoplay: true,
                  autoplaySpeed: 4000
              });
            }
          }else{ //se non ha le frecce
            $this.find('.slider-for').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                fade: true,
                autoplay: true,
                autoplaySpeed: 4000
            });
          }
        }
      }else{ 
        //solo slider in stile dots
        if($this.find('.slider-nav').length >0){
            if(!$this.hasClass('noArrows')){ //se non ha le frecce
              var showBig=4,showMedium=3,showSmall=2;

              if($this.hasClass('eventsOverlay')){
                  showBig=3;
                  showMedium=2;
                  showSmall=1;
              }


              $this.find('.slider-nav').slick({
                  slidesToShow: showBig,
                  slidesToScroll: 1,
                  dots: false,
                  arrows: true,
                  centerMode: false,
                  focusOnSelect: true,
                  autoplay: true,
                  autoplaySpeed: 4000,
                  responsive: [
                  {
                      breakpoint: 1024,
                      settings: {
                      slidesToShow: showMedium,
                      slidesToScroll: showMedium,
                      infinite: true,
                      dots: false
                      }
                  },
                  {
                      breakpoint: 600,
                      settings: {
                      slidesToShow:showMedium,
                      slidesToScroll: showMedium
                      }
                  },
                  {
                      breakpoint: 480,
                      settings: {
                      slidesToShow: showSmall,
                      slidesToScroll: showSmall
                      }
                  }
                  ]
              });
            }else{//se ha le frecce
              var showBig=4,showMedium=3,showSmall=2;

              if($this.hasClass('eventsOverlay')){
                  showBig=3;
                  showMedium=2;
                  showSmall=1;
              }

              $this.find('.slider-nav').slick({
                  slidesToShow: showBig,
                  slidesToScroll: 1,
                  dots: false,
                  arrows: false,
                  centerMode: false,
                  focusOnSelect: true,
                  autoplay: true,
                  autoplaySpeed: 4000,
                  responsive: [
                  {
                      breakpoint: 1024,
                      settings: {
                      slidesToShow: showMedium,
                      slidesToScroll: showMedium,
                      infinite: true,
                      dots: false
                      }
                  },
                  {
                      breakpoint: 600,
                      settings: {
                      slidesToShow: showMedium,
                      slidesToScroll: showMedium
                      }
                  },
                  {
                      breakpoint: 480,
                      settings: {
                      slidesToShow: showSmall,
                      slidesToScroll: showSmall
                      }
                  }
                  ]
              });
            }
        }
      }


    });

  }

  


    if ($(".site-accordion").length > 0) {

      if($(".site-accordion").hasClass('features')){
        moveAccordionItems();

        $(window).on({
          'orientationchange resize': function () {
              moveAccordionItems();
          }
        });
      }
      
      $(".site-accordion .site-accordion__item a").on("click touchend", function(e) {
        e.preventDefault();

       var selectedItem=$(this).attr('href').substring(5);

       $(this).parent('.site-accordion__item').toggleClass('active');
       var openItem = $(this).attr('href').substring(5);
       $('.site-accordion #'+openItem).toggleClass('opened').slideToggle();

       $(".site-accordion .site-accordion__item a").each(function() {
          var closeItem = $(this).attr('href').substring(5);
          if(openItem!=closeItem){
            if($(this).parent('.site-accordion__item').hasClass('active')) $(this).parent('.site-accordion__item').removeClass('active');
            if($('.site-accordion #'+closeItem).hasClass('opened')) $('.site-accordion #'+closeItem).removeClass('opened').slideUp('fast');
          }
       });

       

      });
    }

  // custom select
  $("select.custom-select").each(function() {
    var $this = $(this),
      numberOfOptions = $(this).children("option").length;
    var selectID = $(this).attr("id");
    

    $this.addClass("select-hidden");
    $this.wrap('<div class="select"></div>');
    $this.after('<div class="select-styled"></div>');

    var $styledSelect = $this.next("div.select-styled");
    $styledSelect.text(
      $this
        .children("option")
        .eq(0)
        .text()
    );

    var $list = $("<ul />", {
      class: "select-options"
    }).insertAfter($styledSelect);

    for (var i = 0; i < numberOfOptions; i++) {
      $("<li />", {
        text: $this
          .children("option")
          .eq(i)
          .text(),
        rel: $this
          .children("option")
          .eq(i)
          .val()
      }).appendTo($list);
    }

    var $listItems = $list.children("li");

    $styledSelect.on("click tap", function(e) {
      e.stopPropagation();
      $("div.select-styled.active")
        .not(this)
        .each(function() {
          $(this)
            .removeClass("active")
            .next("ul.select-options")
            .hide();
        });
      $(this)
        .toggleClass("active")
        .next("ul.select-options")
        .toggle();
    });

    $listItems.on("click tap", function(e) {
      e.stopPropagation();
      $(this)
        .parent("ul.select-options")
        .find("li")
        .removeClass("selected")
        .removeAttr("class");
      $styledSelect.text($(this).text()).removeClass("active");
      $(this).addClass("selected");
      $this.val($(this).attr("rel"));
      $list.hide();
      var valSelected = $this.val();
      $("select#"+selectID).val(valSelected).trigger("change");


    });

    $(document).on("click tap", function() {
      $styledSelect.removeClass("active");
      $list.hide();
    });
  });

  $("#trovaEvento").submit(function(e) {
    var s = $(this)
      .find("#location")
      .val(
        $.trim(
          $(this)
            .find("#location")
            .val()
        )
      );
    if (!s.val()) {
      e.preventDefault();
      $("#location").focus();
    }
  });

  $("#searchform").submit(function(e) {
    var s = $(this)
      .find("#s")
      .val(
        $.trim(
          $(this)
            .find("#s")
            .val()
        )
      );
    if (!s.val()) {
      e.preventDefault();
      $("#s").focus();
    }
  });

  $("#quicksearch").submit(function(e) {
    var s = $(this)
      .find("#s2")
      .val(
        $.trim(
          $(this)
            .find("#s2")
            .val()
        )
      );
    if (!s.val()) {
      e.preventDefault();
      $("#s2").focus();
    }
  });

  $(window).scroll(function() {
    if ($(window).scrollTop() >= 50) {
      $(".site-header").addClass("scrolled");
      $(".site-search").addClass("scrolled");
      $(".site-header .site-header__shop").fadeOut(200);
    } else {
      $(".site-header").removeClass("scrolled");
      $(".site-search").removeClass("scrolled");
      $(".site-header .site-header__shop").fadeIn(200);
      
    }

    if ($(this).scrollTop() > 100) {
      $(".scrollToTop").fadeIn();
    } else {
      $(".scrollToTop").fadeOut();
    }
  });

  if ($("img.aligncenter").length > 0) {
    $("img.aligncenter")
      .closest("p")
      .css("textAlign", "center");
  }

  /*$("body:not(.woocommerce) a[href^='#']")
    .not('[href="#"],#closeSearch,#openSearch')
    .on("click touchend", function(e) {
      e.preventDefault();
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {
          $("html,body").animate(
            {
              scrollTop: target.offset().top
            },
            500
          );
          return false;
        }
      }
    });*/

    $("a[href='#listaEventi']").on("click touchend", function(e) {
      e.preventDefault();
      var target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {
          $("html,body").animate(
            {
              scrollTop: target.offset().top
            },
            500
          );
          return false;
        }
    });

    $("a.scrollToTop").on("click touchend", function(e) {
      e.preventDefault();
      var target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {
          $("html,body").animate(
            {
              scrollTop: target.offset().top
            },
            500
          );
          return false;
        }
    });
    

  $("a#closeSearch,a#openSearch").on("click touchend", function(e) {
    e.preventDefault();
    $(".site-search").slideToggle("fast");
  });

  $(".site-header .site-header__hamburger").on("click tap", function(e) {
    e.preventDefault();
    //$('.site-overlay').css('width', '100%');
    $(".site-overlay")
      .removeClass("closed")
      .addClass("opened");
  });

  $(".site-overlay .close").on("click tap", function(e) {
    e.preventDefault();
    //$('.site-overlay').css('width', '0%');
    $(".site-overlay")
      .removeClass("opened")
      .addClass("closed");
  });

  $(".site-overlay__menu ul li.menu-item-has-children a[href='#']").on("click tap", function(e) {
      e.preventDefault();
      $(this).parent('li').find('ul').slideToggle();
  })
});

function is_touch_device() {
  return (
    "ontouchstart" in window || navigator.maxTouchPoints // works on most browsers
  ); // works on IE10/11 and Surface
}

function msieversion() {
  var toReturn = "";
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf("MSIE ");
  var trident = ua.indexOf("Trident/");

  if (msie > 0) {
    toReturn = parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
  } else if (trident > 0) {
    var rv = ua.indexOf("rv:");
    toReturn = parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
  } else {
    toReturn = "other";
  }

  return toReturn;
}




